// V4.2 — six large action cards for the AI-Home. Each card teaches the
// user HOW to talk to the assistant via its example sentence.
import React from "react";
import { useTranslation } from "react-i18next";
import {
  Car, Home, TrendingUp, Globe2, BarChart3, Search, Sparkles,
} from "lucide-react";

const CARD_ICONS = {
  car: Car,
  home: Home,
  "trending-up": TrendingUp,
  globe: Globe2,
  "bar-chart": BarChart3,
  search: Search,
};

export function ActionCards({ actions, onAction, disabled }) {
  const { t } = useTranslation("ai");
  if (!actions?.length) return null;
  return (
    <div
      data-testid="ai-action-cards"
      className="grid grid-cols-2 gap-3 lg:grid-cols-3"
    >
      {actions.map((a) => {
        const Icon = CARD_ICONS[a.icon] || Sparkles;
        const label = t(`actions.${a.slug}.label`, { defaultValue: a.label });
        const example = t(`actions.${a.slug}.example`, { defaultValue: a.example });
        return (
          <button
            key={a.slug}
            type="button"
            data-testid={`ai-chip-${a.slug}`}
            onClick={() => onAction(a.slug)}
            disabled={disabled}
            className="group flex flex-col items-start gap-2 rounded-2xl border border-zinc-800 bg-zinc-900/60 p-4 text-left transition hover:-translate-y-0.5 hover:border-amber-500/50 hover:bg-zinc-900 disabled:opacity-50"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-500/10 text-amber-400 ring-1 ring-amber-500/25 transition group-hover:bg-amber-500/20">
              <Icon className="h-4.5 w-4.5" size={18} />
            </span>
            <span className="text-sm font-medium text-zinc-100">{label}</span>
            <span className="line-clamp-2 text-xs leading-snug text-zinc-500">
              „{example}"
            </span>
          </button>
        );
      })}
    </div>
  );
}
